import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state.socialMarketPartner,
    (state) => state
)

export const selectSocialMarketPartner = createSelector(
    baseSelector,
    (state) => state.partner
)

export const selectSocialMarketPartnerLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)